import { useState } from 'react';

export const useTargetMoisture: any = () => {
  const initialState = {
    targetMoisture: 14,
    shrincageCoeff: 0,
    enableMoistenUnmixed: false,
    bagA: {
      weightGain: 0,
      priceGain: 0,
      moistureCoeff: 0,
    },
    bagB: {
      weightGain: 0,
      priceGain: 0,
      moistureCoeff: 0,
    },
    bagMixed: {
      weightGain: 0,
      priceGain: 0,
      moistureCoeff: 0,
    },
  };
  const [state, setState] = useState(initialState);

  const setInitialState = () => {
    setState(initialState);
  };

  const setTargetMoisture = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      targetMoisture: newValue,
    }));
  };

  const setShrinkageCoeff = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      shrincageCoeff: +newValue.toFixed(3),
    }));
  };

  const setEnableMoistenUnmixed = (newValue: boolean) => {
    setState((prevState) => ({
      ...prevState,
      enableMoistenUnmixed: newValue,
    }));
  };

  const setBagAWeightGain = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagA: {
        ...prevState.bagA,
        weightGain: +newValue.toFixed(3),
      },
    }));
  };

  const setBagBWeightGain = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagB: {
        ...prevState.bagB,
        weightGain: +newValue.toFixed(3),
      },
    }));
  };

  const setBagMixedWeightGain = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagMixed: {
        ...prevState.bagMixed,
        weightGain: +newValue.toFixed(3),
      },
    }));
  };

  const setBagAPriceGain = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagA: {
        ...prevState.bagA,
        priceGain: +newValue.toFixed(3),
      },
    }));
  };

  const setBagBPriceGain = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagB: {
        ...prevState.bagB,
        priceGain: +newValue.toFixed(3),
      },
    }));
  };

  const setBagMixedPriceGain = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagMixed: {
        ...prevState.bagMixed,
        priceGain: +newValue.toFixed(3),
      },
    }));
  };

  const setBagAMoistureCoeff = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagA: {
        ...prevState.bagA,
        moistureCoeff: +newValue.toFixed(3),
      },
    }));
  };

  const setBagBMoistureCoeff = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagB: {
        ...prevState.bagB,
        moistureCoeff: +newValue.toFixed(3),
      },
    }));
  };

  const setBagMixedMoistureCoeff = (newValue: number) => {
    setState((prevState) => ({
      ...prevState,
      bagMixed: {
        ...prevState.bagMixed,
        moistureCoeff: +newValue.toFixed(3),
      },
    }));
  };

  return {
    state,
    setTargetMoisture,
    setShrinkageCoeff,
    setEnableMoistenUnmixed,
    setBagAWeightGain,
    setBagBWeightGain,
    setBagMixedWeightGain,
    setBagAPriceGain,
    setBagBPriceGain,
    setBagMixedPriceGain,
    setInitialState,
    setBagAMoistureCoeff,
    setBagBMoistureCoeff,
    setBagMixedMoistureCoeff,
    setState,
  };
};

export type targetMoistureBagSpecs = {
  priceGain: number;
  weightGain: number;
  moistureCoeff: number;
};

export interface ITargetMoistureData {
  targetMoisture: string;
  shrincageCoeff: number;
  enableMoistenUnmixed: boolean;
  bagA: targetMoistureBagSpecs;
  bagB: targetMoistureBagSpecs;
  bagMixed: targetMoistureBagSpecs;
}
